import { FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { BaseInput, FormBodyContainer } from 'wbs-components-lib';

import { ReferralAssignFormProps } from './types';
import { referralAssignSchema } from './validationSchema';

export const ReferralAssignForm: FC<ReferralAssignFormProps> = ({
  initialValues,
  isSubmitting = false,
  submitButtonCaption = 'Assign',
  onSubmit,
}) => (
  <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={referralAssignSchema} enableReinitialize>
    {({ submitForm, values, handleChange, handleBlur, errors }) => {
      const { referralTelegramNickname: referralTelegramNicknameValue } = values;
      const { referralTelegramNickname: referralTelegramNicknameError } = errors;

      const onReferralsSettingsSubmit = async () => {
        await submitForm();
      };

      const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

      return (
        <FormBodyContainer
          isSubmitting={!!isSubmitting}
          onSubmit={onReferralsSettingsSubmit}
          submitButtonCaption={submitButtonCaption}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
        >
          <BaseInput
            helperText={referralTelegramNicknameError}
            id="referralTelegramNickname"
            name="referralTelegramNickname"
            label="Referral telegram nickname"
            value={referralTelegramNicknameValue}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!referralTelegramNicknameError}
          />
        </FormBodyContainer>
      );
    }}
  </Formik>
);
